export default __webpack_public_path__ + "static/media/committee-chen.b7318951.png";